export default function buildSidebarTree(routes) {
    const routeMap = {};
    const tree = [];

    // Crear mapa
    routes.forEach(route => {
        if (route.meta?.showSidebar === true) {
            routeMap[route.name] = {
                name: route.name,
                label: route.meta?.menuName || route.meta?.title || route.name,
                iconClass: route.meta?.iconClass || 'fa fa-default-icon',
                new: true,
                permission: route.meta?.permission,
                dropdown: null, // inicializamos en null
            };
        }
    });

    // Conectar padres e hijos
    routes.forEach(route => {
        if (route.meta?.showSidebar !== true) return;

        const parentName = route.meta?.parent;
        const routeItem = routeMap[route.name];

        if (parentName && routeMap[parentName]) {
            if (!routeMap[parentName].dropdown) {
                routeMap[parentName].dropdown = []; // inicializamos si no existe
            }
            routeMap[parentName].dropdown.push(routeItem);
        } else if (route.children && route.children.length > 0) {
            const validChildren = route.children
                .filter(child => child.meta?.showSidebar === true)
                .map(child => ({
                    name: child.name,
                    label: child.meta?.menuName || child.meta?.title || child.name,
                    iconClass: child.meta?.iconClass || 'fa fa-default-icon',
                    new: true,
                    permission: child.meta?.permission,
                    dropdown: null,
                }));

            if (validChildren.length > 0) {
                routeItem.dropdown = validChildren;
            }
            tree.push(routeItem);
        } else {
            tree.push(routeItem);
        }
    });

    return tree;
}
